import Validator, { Rules, AttributeNames, ErrorMessages } from 'validatorjs';

export const getFormikValidator = (
  rules: Rules,
  customAttributeNames?: AttributeNames,
  filter?: (data: any, rules: Rules) => Rules,
  customMessages?: ErrorMessages,
) => (data: any) => {
  // eslint-disable-next-line no-param-reassign
  if (filter) rules = filter(data, rules);
  const validator = new Validator(data, rules, customMessages);
  if (customAttributeNames) validator.setAttributeNames(customAttributeNames);
  validator.passes();

  const validation = validator.errors.all();
  const formikValidation: any = {};

  Object.keys(validation).forEach((key) => {
    const [ val ] = validation[key];
    formikValidation[key] = val;
  });

  return formikValidation;
};
